// import RepositoryFactory from "@/apis";
// const linkedin = RepositoryFactory.linkedin;
import linkedin from "../../apis/linkedin";

export default {
  getAuthUrl({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await linkedin.getAuthUrl(payload);
        // console.log(data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getToken({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await linkedin.getToken(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getUserInfo({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await linkedin.getUserInfo(payload);
        // console.log(data);
        // console.log(data.data);
        resolve(data.data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
